<template>
  <div class="min-h-screen bg-slate-950 flex flex-col items-center justify-center relative overflow-hidden font-sans selection:bg-red-500/30">
    <!-- Animated background elements -->
    <div class="absolute top-[-10%] right-[-5%] w-96 h-96 bg-red-600/20 rounded-full blur-[120px] pointer-events-none animate-pulse"></div>
    <div class="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-blue-600/10 rounded-full blur-[120px] pointer-events-none"></div>
    
    <!-- Grid overlay -->
    <div class="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20 pointer-events-none"></div>

    <!-- Main Content Card -->
    <div class="container max-w-2xl px-6 relative z-10 text-center">
      <!-- Icon with Caution Stripes -->
      <div class="relative inline-block mb-10">
        <div class="absolute inset-0 bg-yellow-400 blur-2xl opacity-20 animate-pulse"></div>
        <div class="relative w-32 h-32 md:w-40 md:h-40 rounded-[2.5rem] bg-slate-900 border border-slate-800 flex items-center justify-center shadow-2xl rotate-3 hover:rotate-0 transition-transform duration-500">
           <component :is="AlertTriangle" class="w-16 h-16 md:w-20 md:h-20 text-yellow-400 drop-shadow-[0_0_15px_rgba(250,204,21,0.5)]" />
        </div>
        
        <!-- Caution Tape Effect -->
        <div class="absolute -bottom-4 -right-8 -left-8 h-4 bg-[repeating-linear-gradient(45deg,#000,#000_10px,#fbbf24_10px,#fbbf24_20px)] rounded-full shadow-lg opacity-80 md:block hidden"></div>
      </div>

      <div class="space-y-6">
        <h1 class="text-7xl md:text-9xl font-black text-white tracking-tighter leading-none flex items-center justify-center gap-4">
          4<span class="text-red-600 animate-pulse">0</span>4
        </h1>
        
        <div class="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-500/10 border border-red-500/20 backdrop-blur-md">
            <span class="w-2 h-2 rounded-full bg-red-500 animate-ping"></span>
            <span class="text-xs font-black uppercase tracking-[0.2em] text-red-500">Service Alert: Page Missing</span>
        </div>

        <h2 class="text-2xl md:text-3xl font-extrabold text-slate-100 tracking-tight">
            Security Protocol Triggered
        </h2>
        
        <p class="text-slate-400 text-base md:text-lg font-light max-w-md mx-auto leading-relaxed">
            The equipment or page you are looking for has been moved, removed, or exists in another sector.
        </p>
      </div>

      <div class="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
        <button 
          @click="handleError"
          class="w-full sm:w-auto px-8 py-4 bg-red-600 hover:bg-red-700 text-white font-black uppercase tracking-widest text-xs rounded-2xl transition-all duration-300 shadow-[0_10px_40px_-5px_rgba(220,38,38,0.5)] hover:scale-105 active:scale-95 flex items-center justify-center gap-3"
        >
          <component :is="Home" class="w-4 h-4" />
          Retreat to Safety
        </button>
        
        <NuxtLink 
          to="/shop"
          class="w-full sm:w-auto px-8 py-4 bg-white/5 hover:bg-white/10 text-white border border-white/10 font-black uppercase tracking-widest text-xs rounded-2xl transition-all duration-300 backdrop-blur-md flex items-center justify-center gap-3"
        >
          <component :is="Search" class="w-4 h-4 text-slate-400" />
          Browse Inventory
        </NuxtLink>
      </div>
    </div>

    <!-- Bottom Status Text -->
    <div class="absolute bottom-10 left-0 right-0 text-center opacity-30">
        <p class="text-[10px] font-black text-slate-500 uppercase tracking-[0.5em]">SYSTEM STATUS: NOMINAL (ERROR_CODE: 0x404)</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { AlertTriangle, Home, Search, ArrowLeft } from 'lucide-vue-next'

const props = defineProps({
  error: Object
})

const handleError = () => clearError({ redirect: '/' })

useHead({
  title: 'Page Not Found | ALARM Fire Safety Qatar',
})
</script>

<style scoped>
@keyframes pulse {
  0%, 100% { opacity: 0.2; transform: scale(1); }
  50% { opacity: 0.3; transform: scale(1.1); }
}
.animate-pulse {
  animation: pulse 4s ease-in-out infinite;
}
</style>
